export default "__VITE_ASSET__BZoKycWP__"